import { render, staticRenderFns } from "./materialelement.vue?vue&type=template&id=ebfe585a&"
import script from "./../../ts/articleattributes/materialelement.ts?vue&type=script&lang=js&"
export * from "./../../ts/articleattributes/materialelement.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports